import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import Navbar2 from '../../components/Navbar2/Navbar2'
import Footer from '../../components/footer/Footer'
import Logo from '../../images/logo.svg'
import {
  circles,
  contactEmail,
  hero,
  hurdles,
  partnerBenefits,
  purpose,
  walkthrough,
} from '../../content/csp'

const OverviewPage = () => {
  return (
    <Fragment>
      <Navbar2 />
      <div className="csp-overview">
        <div className="csp-overview-sheet">
          <div className="csp-overview-nav">
            <Link to="/">Back to the site</Link>
            <span>One-pager</span>
          </div>
          <article className="csp-overview-card">
            <header className="csp-overview-brand">
              <img src={Logo} alt="Common Sense Politics" />
              <span>Partner brief</span>
            </header>
            <h1>{hero.title}</h1>
            <p className="csp-lead">{hero.text}</p>

            <div style={{ marginTop: 36 }}>
              <span className="csp-kicker">Who this is for</span>
              <div className="csp-prose">
                {purpose.paragraphs.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </div>
            </div>

            <div style={{ marginTop: 36 }}>
              <span className="csp-kicker">What has to happen</span>
              <div className="csp-grid csp-grid--3">
                {hurdles.map((hurdle) => (
                  <article className="csp-card" key={hurdle.title}>
                    <h3>{hurdle.title}</h3>
                    <p>{hurdle.text}</p>
                  </article>
                ))}
              </div>
            </div>

            <div style={{ marginTop: 36 }}>
              <span className="csp-kicker">What a partner gets</span>
              <div className="csp-prose">
                <ul>
                  {partnerBenefits.map((benefit) => (
                    <li key={benefit.title}>
                      <strong>{benefit.title}.</strong> {benefit.text}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div style={{ marginTop: 36 }}>
              <span className="csp-kicker">{circles.kicker}</span>
              <p className="csp-lead">{circles.lead}</p>
              <div className="csp-levels">
                {circles.levels.map((level) => (
                  <article className="csp-level" key={level.title}>
                    <span className="csp-level-label">Circle</span>
                    <h3>{level.title}</h3>
                    <p>{level.text}</p>
                  </article>
                ))}
              </div>
            </div>

            <div style={{ marginTop: 36 }}>
              <span className="csp-kicker">{walkthrough.kicker}</span>
              <p className="csp-lead">{walkthrough.text}</p>
            </div>

            <div className="csp-overview-actions">
              <Link className="theme-btn" to="/contact">
                <span className="text">{walkthrough.action}</span>
              </Link>
              <Link className="csp-more" to="/how-it-works">
                See how your Circle would work
              </Link>
            </div>
            <p className="csp-lead" style={{ marginTop: 20 }}>
              {contactEmail}
            </p>
          </article>
        </div>
      </div>
      <Footer />
    </Fragment>
  )
}

export default OverviewPage
